<div class="icard">
  <div>
    <mat-icon>file_present_rounded</mat-icon>
  </div>
  <div class="name">
    <p>{{ file.name }}</p>
  </div>
  <div class="options">
    <div class="buttons">
      <mat-icon (click)="view()">visibility</mat-icon>
      <mat-icon (click)="download()">file_download</mat-icon>
      <mat-icon (click)="delete()" *ngIf="canEdit && !status">delete</mat-icon>
    </div>
    <p class="date">{{ date }}</p>
  </div>
</div>
